import React from 'react';
import { MiniRidesApp } from './components/MiniRides/MiniRidesApp';
export function App() {
  return <MiniRidesApp data-id="element-0" />;
}